// extracted by mini-css-extract-plugin
export default {"In_bio":"Bio_In_bio__KDKk4","container":"Bio_container__KaAuU","bioinner":"Bio_bioinner__feHQu"};